import React, { useState, useEffect } from 'react'
import Map from './Map'
import {
  Grid,
  Box,
  Modal,
  FormControl,
  TextField,
  Button,
  Tooltip,
} from '@material-ui/core'
import { useCurrentPosition } from 'react-use-geolocation'
import { Form } from 'antd'
import './style.css'
import Paper from '@mui/material/Paper'
import InputBase from '@mui/material/InputBase'
import Divider from '@mui/material/Divider'
import SaveIcon from '@mui/icons-material/Save'
import CloseIcon from '@mui/icons-material/Close'
import swal from 'sweetalert'
import { useFormElegibilidad } from '../../../../context/ElegibilidadContext'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { saveLocation } from '../../../../services/Elegibilidad/create'
import ReactTooltip from 'react-tooltip'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import LocationOnIcon from '@mui/icons-material/LocationOn'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 700,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  paddingRight: '45px',
  height: 670,
}

export const ModalMaps = ({
  open,
  setOpen,
  getDataTableLocation,
  saveForm,
}) => {
  const { idElegibilityForm } = useFormElegibilidad()
  const [position] = useCurrentPosition()
  const [positionsCurrent, setpositionsCurrent] = useState({})
  const [polygones, setpolygones] = useState(undefined)
  const [loading, setLoading] = useState(false)

  const GeneralDataSchema = Yup.object().shape({
    address: Yup.string()
      .required('Este Campo es obligatorio')
      .max(100, 'Máximo 100 caracteres'),
    lat: Yup.string().required('Este Campo es obligatorio'),
    lng: Yup.string().required('Este Campo es obligatorio'),
  })

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      address: '',
      lat: '',
      lng: '',
    },
    validationSchema: GeneralDataSchema,
    onSubmit: () => {
      handleGuardar()
    },
  })

  const validateFormStatus = () => {
    if (!formik.isValid) {
      alertValidationFields()
    }
  }
  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const handleClose = () => {
    setOpen(false)
    setpositionsCurrent({})
    formik.resetForm()
  }

  useEffect(() => {
    if (position && Object.entries(positionsCurrent).length === 0) {
      setpositionsCurrent({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      })
      formik.setValues({
        ...formik.values,
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      })
    }
  }, [position, positionsCurrent])

  const onFinish = async (values) => {
    values.coordinates = {
      latitude: values.latitude,
      longitude: values.longitude,
    }
    delete values.latitude
    delete values.longitude
    setpositionsCurrent({})
  }

  const onDragend = (value, maps) => {
    setpositionsCurrent({
      lat: maps.position.lat(),
      lng: maps.position.lng(),
    })
    setpolygones()
    formik.setValues({
      ...formik.values,
      lat: maps.position.lat(),
      lng: maps.position.lng(),
    })
  }

  const handleGuardar = async () => {
    setLoading(true)
    const body = {
      IdProjectDevelopmentLocation: 0,
      IdElegibilityAnswer: idElegibilityForm,
      Latitud: positionsCurrent.lat.toString(),
      Longitude: positionsCurrent.lng.toString(),
      Address: formik.values.address,
    }
    const response = await saveLocation(body)
    if (response.Success) {
      swal({
        title: '¡Datos guardados exitosamente!',
        icon: 'success',
      })
      getDataTableLocation()
      formik.resetForm()
      handleClose()
      setLoading(false)
      saveForm()
    }
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form id="transfers-form" onSubmit={formik.handleSubmit}>
            <Grid container>
              <Grid item xs={12} sm={12} md={12}>
                <span
                  className="span-modal"
                  style={{ fontWeight: 'bold', color: 'black' }}
                >
                  * Mueva el marcador sobre la dirección exacta.
                </span>
                <Tooltip
                  title={
                    <>
                      Si usted no puede visualizar el mapa, seguramente ha
                      bloqueado el permiso de acceder a su ubicación. <br />
                      Para habilitarlo haga: Arriba a la derecha, en la barra de
                      direcciones, toca el icono <LocationOnIcon />
                      <br />
                      luego seleccionar siempre permitir al sitio el acceso a la
                      ubicación.
                    </>
                  }
                >
                  <a style={{ cursor: 'pointer' }}>
                    {/* <div data-tip="info82Pop" data-for="info82Pop" data-place="top"> */}
                    <ErrorOutlineIcon fontSize="small" />
                    <ReactTooltip
                      id="info82Pop"
                      effect="solid"
                      multiline={true}
                      type="dark"
                    />
                    {/* </div> */}
                  </a>
                </Tooltip>
                <Form onFinish={onFinish}>
                  <Map
                    onDragend={onDragend}
                    draggable
                    positions={positionsCurrent}
                    zoom={11.2}
                    polygones={polygones}
                  />
                </Form>
              </Grid>

              <Grid container spacing={1} className="input__containerMaps">
                <Grid item xs={12} sm={6} md={6}>
                  <Paper
                    component="form"
                    sx={{
                      p: '2px 4px',
                      display: 'flex',
                      alignItems: 'center',
                      width: '98%',
                      // backgroundColor: '#c6c7c9',
                      border: '1px solid gray',
                      marginRight: '10px',
                    }}
                  >
                    <label className="responsiveLabelMaps">Latitud</label>
                    <Divider
                      sx={{ height: 28, m: 0.5 }}
                      orientation="vertical"
                    />
                    <InputBase
                      sx={{ ml: 1, flex: 1 }}
                      placeholder="Search Google Maps"
                      inputProps={{ 'aria-label': 'search google maps' }}
                      style={{ backgroundColor: 'white' }}
                      value={positionsCurrent.lat}
                      disabled
                    />
                  </Paper>
                  {formik.errors.lat ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.lat}
                    </div>
                  ) : null}
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Paper
                    component="form"
                    sx={{
                      p: '2px 4px',
                      display: 'flex',
                      alignItems: 'center',
                      width: '98%',
                      marginLeft: '10px',
                      // backgroundColor: '#c6c7c9',
                      border: '1px solid gray',
                    }}
                  >
                    <label className="responsiveLabelMaps">Longitud</label>
                    <Divider
                      sx={{ height: 28, m: 0.5 }}
                      orientation="vertical"
                    />
                    <InputBase
                      sx={{ ml: 1, flex: 1 }}
                      placeholder="Search Google Maps"
                      inputProps={{ 'aria-label': 'search google maps' }}
                      style={{ backgroundColor: 'white' }}
                      disabled
                      value={positionsCurrent.lng}
                    />
                  </Paper>
                  <Grid container style={{ marginLeft: '4%' }}>
                    {formik.errors.lng ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.lng}
                      </div>
                    ) : null}
                  </Grid>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="input__dic">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">Dirección:</label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <TextField
                      placeholder="Dirección"
                      style={{ width: '102%' }}
                      variant="outlined"
                      error={formik.errors.address}
                      onChange={(e) => {
                        formik.setFieldValue('address', e.target.value)
                      }}
                      value={formik.values.address}
                      inputProps={{ maxLength: 100 }}
                    />
                    {formik.errors.address ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.address}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid className="buttonsPYME" style={{ marginLeft: '2%' }}>
              <Button
                className="cancelButton"
                startIcon={<CloseIcon />}
                onClick={() => handleClose()}
              >
                Cancelar
              </Button>
              <Button
                className="confirmButton"
                type="submit"
                startIcon={<SaveIcon />}
                onClick={validateFormStatus}
                disabled={loading}
              >
                Guardar
              </Button>
            </Grid>
          </form>
        </Box>
      </Modal>
    </>
  )
}
